import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers"; // ✅ Ensure this is the only import for DatePicker

import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Autocomplete,
  TextareaAutosize,
  Switch,
  FormControlLabel,
  Grid,
} from "@mui/material";

import styled from "@emotion/styled";

import {
  createTerreni,
  fetchEsposizione,
  fetchTipoSuolo,
  fetchSistemaColtivazione,
  fetchTerreni,
  fetchSingleTerreni,
  updateSingleTerreni,
  fetchCultura,
  fetchUliveto,
  fetchVarieta,
} from "../../../features/terreni/terreniThunk";
import {
  selectEsposizione,
  selectTipoSuolo,
  selectSistemaColtivazione,
  selectVarieta,
  selectUliveto,
  selectCultura,
} from "../../../features/terreni/terreniSlice";
import dayjs from "dayjs";
import "dayjs/locale/it";
import {
  fetchCities,
  fetchProvincies,
  fetchRegions,
} from "../../../features/region/regionThunk";
import { selectCantines } from "../../../features/cantine/cantineSlice";
import { fetchCompanies } from "../../../features/company/companyThunk";
import { fetchCantines } from "../../../features/cantine/cantineThunk";
dayjs.locale("it");

const Textarea = styled(TextareaAutosize)`
  box-sizing: border-box;
  width: 100%;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 5px;
  color: #160a2a;
  background: #fff;
  border: 2px solid #e5e5e5;
`;

// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    onChange(event);
  };

  return (
    <Textarea
      aria-label="empty textarea"
      placeholder={placeholder}
      minRows={4}
      value={inputValue}
      onChange={handleChange}
    />
  );
};

const options = ["Amministratore", "Collaboratore", "Operatore"];

const dmsRegex = /^(\d{1,2}°\d{2}'\d{2}"[NS])\s(\d{1,3}°\d{2}'\d{2}"[EW])$/;

const schema = yup.object().shape({
  nome: yup.string().required("Nome del terreno è richiesta"),
  superficie_totale: yup
    .string()
    .matches(
      /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/, // Allow numbers, commas, and dots
      "La superficie totale deve essere un numero valido con il punto"
    )
    .required("Superficie totale è richiesta"),

  superficie_coltivata: yup
    .string()
    .matches(
      /^[0-9]+([,][0-9]+)*([.][0-9]+)?$/, // Allow numbers, commas, and dots
      "La superficie totale deve essere un numero valido con il punto"
    )
    .required("Superficie coltivata è richiesta"),

  zona: yup.string().required("zona è richiesta"),
  comune: yup.string().required("Comune è richiesta"),
  cap: yup
    .string()
    .required("CAP è obbligatoria")
    .matches(/^\d{5}$/, "Il CAP deve essere composto esattamente da 5 cifre"),
  provincia: yup.string().required("FR è richiesta"),
  regione: yup.string().required("Regione è richiesta"),
  nazione: yup.string().required("nazione è richiesta"),
  altitudine: yup
    .string()
    .matches(/^\d+$/, "L'altitudine deve essere un numero")
    .required("Altitudine è richiesta"),
  esposizione: yup.string().required("Esposizione è richiesta"),
  cantina: yup.mixed(),
  tipo_suolo: yup.string().required("Tipo di suolo è richiesta"),
  irrigazione: yup
    .boolean()
    .oneOf([true, false], "Irrigazione deve essere true o false")
    .required("Irrigazione è richiesta"),
  sistema_coltivazione: yup
    .string()
    .required("Sistema di coltivazione è richiesta"),
  cultura: yup.string().required("cultura è richiesta"),
  varieta: yup.mixed().required("varieta è richiesta"),
  // uliveto: yup.string().required("uliveto è richiesta"),
  // citta: yup.string().required("Città è obbligatoria"),
  coordinate_gps: yup
    .string()
    .required("Coordinate GPS sono richieste")
    .matches(
      dmsRegex,
      "Le coordinate GPS devono essere nel formato DMS: 41°45'09\"N 13°38'16\"E"
    ),
  data_acquisizione: yup
    .date()
    .typeError("Inserisci una data valida")
    .required("La data di acquisizione è richiesta"),
});
const TerreniForm = ({
  cantine,
  setCantine,
  singleData,
  cantineSingleData,
}) => {
  const dispatch = useDispatch();
  console.log(singleData, "singleData221");

  const { provincies, regions, cities } = useSelector((state) => state.region);
  // console.log("hiby", provincies);
  // console.log("by", regions);
  // console.log("cities", cities)

  const [selectedCultura, setSelectedCultura] = useState("");
  const [filteredVarietaOptions, setFilteredVarietaOptions] = useState([]);

  // Fetch enum options from Redux store
  const esposizioneOptions = useSelector(selectEsposizione);
  const tipoSuoloOptions = useSelector(selectTipoSuolo);
  const sistemaColtivazioneOptions = useSelector(selectSistemaColtivazione);
  const CantineData = useSelector(selectCantines);

  const culturaOptions = useSelector(selectCultura);
  const ulivetoOptions = useSelector(selectUliveto);
  const varietaOptions = useSelector(selectVarieta);

  // console.log("culturaOptions", culturaOptions);
  // console.log("ulivetoOptions", ulivetoOptions);
  // console.log("varietaOptions", varietaOptions);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      nome: "",
      superficie_totale: "",
      superficie_coltivata: "",
      zona: "",
      comune: "",
      provincia: "",
      regione: "",
      nazione: "",
      altitudine: "",
      esposizione: "",
      cantina: "",
      tipo_suolo: "",
      irrigazione: "",
      sistema_coltivazione: "",
      cultura: "",
      varieta: [],
      // uliveto: "",
      city: "",
      coordinate_gps: "",
      data_acquisizione: null,
      note: "",
      cap: "",
      // fr: "",
    },
  });
  // console.log(errors, "errors");

  useEffect(() => {
    dispatch(fetchEsposizione());
    dispatch(fetchTipoSuolo());
    dispatch(fetchSistemaColtivazione());
    dispatch(fetchCultura());
    dispatch(fetchUliveto());
    dispatch(fetchVarieta());
    dispatch(fetchCantines());
    // console.log(cantineSingleData, "terrenicantine");

    // Only fetch region data if not already in the store
    if (!regions || regions.length === 0) {
      dispatch(fetchRegions());
    }
    if (!provincies || provincies.length === 0) {
      dispatch(fetchProvincies());
    }
    if (!cities || cities.length === 0) {
      dispatch(fetchCities());
    }

    if (!cantine) {
      // Transform data to ensure it matches expected format
      const formattedData = {
        ...singleData,
        data_acquisizione: singleData?.data_acquisizione
          ? dayjs(singleData?.data_acquisizione)
          : null,
        esposizione:
          typeof singleData?.esposizione === "object"
            ? singleData?.esposizione?.nome
            : singleData?.esposizione,
        tipo_suolo:
          typeof singleData?.tipo_suolo === "object"
            ? singleData?.tipo_suolo.nome
            : singleData?.tipo_suolo,
        sistema_coltivazione:
          typeof singleData?.sistema_coltivazione === "object"
            ? singleData?.sistema_coltivazione.nome
            : singleData?.sistema_coltivazione,
        cultura:
          typeof singleData?.cultura === "object"
            ? singleData?.cultura?.nome
            : singleData?.cultura,
        varieta: singleData?.varieta
          ? singleData.varieta.split(",").map((v) => v.trim())
          : [],



        // ✅ Add cantina logic
        cantina:
          typeof singleData?.cantina_id === "object"
            ? singleData?.cantina_id
            : CantineData.find((c) => c.id === singleData?.cantina_id) || null,
      };

      reset(formattedData);
    }
  }, [dispatch, cantine, singleData, reset]);

  useEffect(() => {
    if (singleData?.cultura) {
      // Handle both object and string cases
      const culturaValue =
        typeof singleData.cultura === "object"
          ? singleData.cultura.nome
          : singleData.cultura;

      setSelectedCultura(culturaValue);
    }
  }, [singleData]);

  useEffect(() => {
    // Get the cultura name consistently whether it's an object or string
    const culturaName =
      typeof selectedCultura === "object"
        ? selectedCultura?.nome
        : selectedCultura;

    console.log("Selected cultura:", culturaName); // For debugging

    if (culturaName === "Uliveto") {
      // For Uliveto, use ulivetoOptions
      const options = Array.isArray(ulivetoOptions)
        ? ulivetoOptions
        : ulivetoOptions?.data || [];

      console.log("Filtered uliveto options:", options); // For debugging
      setFilteredVarietaOptions(options);
    } else if (culturaName === "Varieta" || culturaName === "Vigneto") {
      // Consider adding other cultura types
      // For Varieta/Vigneto, use varietaOptions
      const options = Array.isArray(varietaOptions)
        ? varietaOptions
        : varietaOptions?.data || [];

      console.log("Filtered varieta options:", options); // For debugging
      setFilteredVarietaOptions(options);
    } else {
      // For any other cultura or undefined, show an empty list
      setFilteredVarietaOptions([]);
    }
  }, [selectedCultura, ulivetoOptions, varietaOptions]);
  const nationOptions = ["Italia", "Francia", "Germania", "Spagna"];

  const onSubmit = async (data) => {
    try {
      // console.log(data.irrigazione, "irrigazione");
      const cantinaId = data.cantina?.id;
      const varietaString = data.varieta
        .map((item) => (typeof item === "string" ? item : item?.nome))
        .join(", ");

      const terreniData = {
        company_id: localStorage.getItem("company_id"),
        // cantina_id: localStorage.getItem("cantine_id"),
        nome: data.nome,
        superficie_totale: data.superficie_totale,
        superficie_coltivata: data.superficie_coltivata,
        zona: data.zona,
        comune: data.comune,
        provincia: data.provincia,
        cap: data.cap,
        regione: data.regione,
        nazione: data.nazione,
        altitudine: data.altitudine,
        esposizione: data.esposizione,
        cantina_id: cantinaId,
        tipo_suolo: data.tipo_suolo,
        irrigazione: data.irrigazione,
        sistema_coltivazione: data.sistema_coltivazione,
        cultura: data.cultura,
        varieta: varietaString,
        // uliveto: data.uliveto,
        // citta: data.citta,
        coordinate_gps: data.coordinate_gps,
        // data_acquisizione: data.data_acquisizione,
        data_acquisizione: data.data_acquisizione
          ? dayjs(data.data_acquisizione).format("YYYY-MM-DD")
          : null,
        note: data.note,
      };

      if (!cantine) {
        // console.log("Updating cantine with ID:", singleData?.id);
        await dispatch(
          updateSingleTerreni({
            terreniId: singleData.id,
            terreniData,
          })
        ).unwrap();

        dispatch(fetchSingleTerreni(singleData.id));

        reset();
        // if (onClose) onClose();

        // console.log("Terreni updated successfully!");
      } else {
        // Creating new terreni
        await dispatch(createTerreni(terreniData)).unwrap();
        dispatch(fetchTerreni());
        setCantine(false);
        reset();
        // if (onClose) onClose();

        // console.log("Terreni created successfully!");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
      <div className="AziendaFrom__inner">
        {!cantine && <Typography mb={"10px"}>ID=0001</Typography>}

        {singleData?.cantina_id !== null && !cantineSingleData && (
          <Controller
            defaultValue={null}
            name="cantina"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={CantineData}
                getOptionLabel={(option) => option.name || ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="cantina"
                    className="customTextBox autoCompleteTextBox"
                    margin="normal"
                    fullWidth
                    error={!!errors.cantina}
                    helperText={errors.cantina?.message}
                  />
                )}
                onChange={(_, value) => field.onChange(value)}
                value={field.value || null}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            )}
          />
        )}

        <Controller
          defaultValue=""
          name="nome"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              className="customTextBox"
              label="ID e nome del terreno"
              fullWidth
              margin="normal"
              error={!!errors.nome}
              helperText={errors.nome?.message}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="superficie_totale"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              className="customTextBox"
              label="Superficie totale (ha)"
              fullWidth
              margin="normal"
              error={!!errors.superficie_totale}
              helperText={errors.superficie_totale?.message}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="superficie_coltivata"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Superficie coltivata (ha)"
              className="customTextBox"
              fullWidth
              margin="normal"
              error={!!errors.superficie_coltivata}
              helperText={errors.superficie_coltivata?.message}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="zona"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Zona"
              className="customTextBox"
              fullWidth
              margin="normal"
              error={!!errors.zona}
              helperText={errors.zona?.message}
            />
          )}
        />
        {/* 
        <Controller
          defaultValue=""
          name="comune"
          control={control}
          render={({ field }) => (
            <Autocomplete
              {...field}
              options={cities?.map((cities) => cities.comune) || []}
              onChange={(event, value) => field.onChange(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Comune"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.comune}
                  helperText={errors.comune?.message}
                />
              )}
            />
          )}
        /> */}
        <Grid container spacing={1}>
          <Grid size={9}>
            <Controller
              defaultValue=""
              name="comune"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={cities?.map((cities) => cities.comune) || []}
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Città"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.comune}
                      helperText={errors.comune?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={3}>
            <Controller
              defaultValue=""
              name="cap"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="CAP"
                  className="customTextBox"
                  fullWidth
                  margin="normal"
                  error={!!errors.cap}
                  helperText={errors.cap?.message}
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid size={4}>
            <Controller
              defaultValue=""
              name="provincia"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={
                    provincies?.map((provincia) => provincia.provincia) || []
                  }
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="PR"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.provincia}
                      helperText={errors.provincia?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={5}>
            <Controller
              defaultValue=""
              name="regione"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={regions?.map((regione) => regione.regione) || []}
                  onChange={(event, value) => field.onChange(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Regione"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.regione}
                      helperText={errors.regione?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid size={3}>
            <Controller
              defaultValue=""
              name="nazione"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={nationOptions}
                  value={field.value || ""}
                  onChange={(event, newValue) => {
                    field.onChange(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Nazione"
                      className="customTextBox autoCompleteTextBox"
                      margin="normal"
                      fullWidth
                      error={!!errors.nazione}
                      helperText={errors.nazione?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
        </Grid>

        <Controller
          defaultValue=""
          name="altitudine"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Altitudine (m)"
              className="customTextBox"
              fullWidth
              margin="normal"
              error={!!errors.altitudine}
              helperText={errors.altitudine?.message}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="esposizione"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={esposizioneOptions.map((opt) => opt.nome || opt)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Esposizione"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.esposizione}
                  helperText={errors.esposizione?.message}
                />
              )}
              onChange={(_, value) => field.onChange(value)}
              value={field.value || null}
              isOptionEqualToValue={(option, value) =>
                option === value ||
                (typeof option === "object" && option?.nome === value)
              }
            />
          )}
        />
        <Controller
          defaultValue=""
          name="tipo_suolo"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={tipoSuoloOptions.map((opt) => opt.nome || opt)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  label="Tipo di suolo"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.tipo_suolo}
                  helperText={errors.tipo_suolo?.message}
                />
              )}
              onChange={(_, value) => field.onChange(value)}
              value={field.value}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="irrigazione"
          control={control}
          render={({ field }) => (
            <TextField
              select
              className="customTextBox"
              {...field}
              label="Irrigazione"
              fullWidth
              margin="normal"
              error={!!errors.irrigazione}
              helperText={errors.irrigazione?.message}
            >
              <MenuItem value={true}>SI</MenuItem>
              <MenuItem value={false}>NO</MenuItem>
            </TextField>
          )}
        />

        <Controller
          defaultValue=""
          name="sistema_coltivazione"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={sistemaColtivazioneOptions.map((opt) => opt.nome || opt)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  label="Sistema di coltivazione"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.sistema_coltivazione}
                  helperText={errors.sistema_coltivazione?.message}
                />
              )}
              onChange={(_, value) => field.onChange(value)}
              value={field.value}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="cultura"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={culturaOptions?.map((opt) => opt?.nome || opt)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  label="Cultura"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.cultura}
                  helperText={errors.cultura?.message}
                />
              )}
              onChange={(_, value) => {
                // Update both form field value and local state
                field.onChange(value);
                setSelectedCultura(value);
              }}
              value={field.value}
            />
          )}
        />

        <Controller
          defaultValue=""
          name="varieta"
          control={control}
          render={({ field }) => (
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={filteredVarietaOptions.map((opt) =>
                typeof opt === "string" ? opt : opt.nome
              )}
              value={field.value || []}
              onChange={(_, value) => field.onChange(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={field.value?.length > 0 ? '' : "Varietà"}
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.varieta}
                  helperText={errors.varieta?.message}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          )}
        />



        {/* <Controller
          defaultValue=""
          name="uliveto"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={ulivetoOptions.map((opt) => opt.nome || opt)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...field}
                  label="Uliveto"
                  className="customTextBox autoCompleteTextBox"
                  margin="normal"
                  fullWidth
                  error={!!errors.uliveto}
                  helperText={errors.uliveto?.message}
                />
              )}
              onChange={(_, value) => field.onChange(value)}
              value={field.value}
            />
          )}
        /> */}

        <Controller
          defaultValue=""
          name="coordinate_gps"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Coordinate GPS"
              className="customTextBox"
              fullWidth
              margin="normal"
              error={!!errors.coordinate_gps}
              helperText={errors.coordinate_gps?.message}
            />
          )}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <Controller
            defaultValue=""
            name="data_acquisizione"
            control={control}
            render={({ field }) => (
              <DatePicker
                className="datePickerField"
                label="Data Acquisizione"
                value={field.value}
                onChange={(newValue) => field.onChange(newValue)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "normal",
                    className: "customTextBox",
                    error: !!errors.data_acquisizione,
                    helperText: errors.data_acquisizione?.message,
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>

        <Controller
          defaultValue=""
          name="note"
          control={control}
          render={({ field }) => (
            <EmptyTextarea placeholder="Note" {...field} />
          )}
        />

        <div className="btnPart1">
          <Button type="submit" variant="contained">
            Salva dati
          </Button>
        </div>
      </div>
    </form>
  );
};

export default TerreniForm;
